import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector, reset } from "redux-form";
import { renderInput, renderTextArea, renderDatePicker, renderDropdown, renderCheckbox } from "../common/renderinput";
import { Nav,NavItem,NavLink,TabContent,TabPane } from 'reactstrap';
import classnames from 'classnames';

const q = [
    {valueField: 1, textField:"Confirmation Order"},
    {valueField: 2, textField:"Corrective Deed"},
    {valueField: 3, textField:"Deed In Lieu"},
    {valueField: 4, textField:"Foreclosure Deed"},
    {valueField: 5, textField:"Quit Claim Deed"},
    {valueField: 6, textField:"Sheriff’s Deed"},
    {valueField: 7, textField:"Special Warranty Deed"},
    {valueField: 8, textField:"Trustees Deed"}
];
class DeedForm extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
             activeTab: '1'
        };
    }
    toggle = tab => {

        if (this.state.activeTab !== tab)
            this.setState(prevState => ({
                ...prevState, activeTab: tab
            }));
    }
    render() {
        return (
          <>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: this.state.activeTab === '1' })}
                                    onClick={() => { this.toggle('1'); }}>Grantee</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: this.state.activeTab === '2' })}
                                    onClick={() => { this.toggle('2'); }}>Grantor</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: this.state.activeTab === '3' })}
                                    onClick={() => { this.toggle('3'); }}>Deed</NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={this.state.activeTab}>
                                            <TabPane tabId="1">
                                            {this.state.activeTab === '1' &&
                                            <div className="form-row col-12 pl-0 mt-2">
                                                <div className="col-4">
                                                    <Field
                                                    name="Grantee"
                                                    component={renderTextArea}
                                                    label="Grantee"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-4">
                                                    <Field
                                                    name="Vesting"
                                                    component={renderTextArea}
                                                    label="Grantee Vesting"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-4">
                                                    <Field
                                                    name="NameLegal"
                                                    component={renderTextArea}
                                                    label="Name on Legal"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-4">
                                                    <Field
                                                    name="Deceased"
                                                    type="checkbox"
                                                    component={renderCheckbox}
                                                    label="Is Deceased?"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-4">
                                                    <Field
                                                    name="DeceasedDate"
                                                    component={renderDatePicker}
                                                    label="Deceased Date"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-4">
                                                    <Field
                                                    name="DeceasedName"
                                                    component={renderTextArea}
                                                    label="Deceased Name"
                                                    isLabel={true}
                                                    />
                                                </div>
                                            </div>}
                                            </TabPane>
                                            <TabPane tabId="2">
                                            {this.state.activeTab === '2' &&
                                            <div className="form-row col-12 pl-0 mt-2">
                                                <div className="col-4">
                                                    <Field
                                                    name="Grantor"
                                                    component={renderTextArea}
                                                    label="Grantor"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-4">
                                                    <Field
                                                    name="GrantorVesting"
                                                    component={renderTextArea}
                                                    label="Grantor Vesting"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-4">
                                                    <Field
                                                    name="GrantorNameLegal"
                                                    component={renderTextArea}
                                                    label="Name on Legal"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-4">
                                                    <Field
                                                    name="GrantorDeceased"
                                                    component={renderCheckbox}
                                                    label="Is Deceased?"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-4">
                                                    <Field
                                                    name="GrantorDeceasedDate"
                                                    component={renderDatePicker}
                                                    label="Deceased Date"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-4">
                                                    <Field
                                                    name="GrantorDeceasedName"
                                                    component={renderTextArea}
                                                    label="Deceased Name"
                                                    isLabel={true}
                                                    />
                                                </div>
                                            </div>}                                                
                                            </TabPane>
                        </TabContent>



            {this.state.activeTab == '3' &&
            <div className="form-row col-12 pl-0 mt-2">
              <div className="col-3">
                <Field
                  name="DeedDate"
                  component={renderDatePicker}
                  label="Deed Date"
                  isLabel={true}
                />
              </div>

              <div className="col-3">
                <Field
                  name="RecordedDate"
                  component={renderDatePicker}
                  label="Recorded Date"
                  isLabel={true}
                />
              </div>
              <div className="col-3">
                <Field
                  name="DeedType"
                  component={renderDropdown}
                  label="Deed Type"
                  data={q}
                  textField="textField"
                  valueField="valueField"
                  isLabel={true}
                />
              </div>

              <div className="col-3">
                <Field
                  name="ConsiderationAmount"
                  component={renderInput}
                  label="Cons. Amount"
                  isLabel={true}
                />
              </div>
            </div>}
            {this.state.activeTab == '3' &&
            <div className="form-row col-12 pl-0 mt-2">
              <div className="col-3">
                <Field
                  name="VolInst"
                  component={renderInput}
                  label="Vol/Inst"
                  isLabel={true}
                />
              </div>
              <div className="col-3">
                <Field
                  name="Page"
                  component={renderInput}
                  label="Page"
                  isLabel={true}
                />
              </div>
              <div className="col-4">
                <Field
                  name="Prior"
                  type="checkbox"
                  component={renderCheckbox}
                  label="Prior Deed"
                  isLabel={true}
                />
              </div>
            </div>}
            {this.state.activeTab == '3' &&
            <div className="form-row col-12 pl-0 ">
              <div className="col-12">
                <Field
                  name="Comments"
                  component={renderTextArea}
                  label="Comments"
                  isLabel={true}
                />
              </div>
            </div>}

          </>
        );
    }
}
export default DeedForm;